import React, { Component } from "react"
import ReactDOM from "react-dom"
import styled from "styled-components"
import {media} from "utils/Media"
import { TimelineMax } from "gsap"
import isTouchDevice from "is-touch-device"
import { CircularProgressbar } from 'react-circular-progressbar'
import 'react-circular-progressbar/dist/styles.css'

const ButtonWrap = styled.div`
    position: absolute;
    z-index: 19;
    bottom: 0.25rem;
    left: 50%;
    transform: translateX(-50%) scale(0.66);
    width: 110px;
    height: 110px;
    cursor: pointer;
    opacity: 1;
    transition: all .5s ease;

    &.hide {
        opacity: 0;
    }
    
    @media ${media.lg} {
        bottom: 3rem;
    }    
    
    @media ${media.disney} {
        transform: translateX(-50%) scale(1);
    }
`

const CircleWrap = styled.div`
    height: 60px;
    width:  60px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    align-items: center;
    justify-content: center;
`

const Circle = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    height: 60px;
    width:  60px;
    border-radius: 50%;
    background-color: white;
    font-family: ${props => props.theme.font.family.bold};
    user-select: none;
    opacity: 0;
`

const CircleText = styled.div`
    opacity: 0;
    color: black;
    position: relative;
    z-index: 1;
    font-family: ${props => props.theme.font.family.bold};
    font-size: 1.15rem;
    text-align: center;
    line-height: 1rem;
    pointer-events: none;

    span {
        font-family: ${props => props.theme.font.family.bold};
        display: inline;
        user-select: none;
    }
`

class ButtonSwipe extends Component {
    constructor(props) {
        super(props)

        this.state = {
            timeToLoad: 1250,
            percentage: 0
        }

        this.masterTimeline = new TimelineMax({ paused: true })

        this.onTouchComplete = this.onTouchComplete.bind(this)
        this.onTouchStart = this.onTouchStart.bind(this)
        this.onTouchEnd = this.onTouchEnd.bind(this)

        this.interval = null
    }


    componentDidMount() {
        // create animation
        this.initialAnimation()
    }

    componentDidUpdate() {
        if (this.props.play) {
            // play animation
            this.masterTimeline.play()
        }
    }

    componentWillUnmount() {
        // Kill on unmount
        this.masterTimeline.kill()
    }

    initialAnimation() {
        const buttonCircleTimeline = new TimelineMax()
        const buttonCircleTextTimeline = new TimelineMax()

        buttonCircleTimeline
            .to(this.circle, .4, { width: "100px", height: "100px", opacity: .8, delay: 0.2 })
            .to(this.circle, .2, { width: "90px", height: "90px", opacity: 1 })
            .to(this.circle, .3, { width: "100px", height: "100px", delay: .5 })
            .to(this.circle, .3, { width: "90px", height: "90px" })

        buttonCircleTextTimeline
            .to(this.circleText, .4, { opacity: 1, delay: 0.5 })

        this.masterTimeline
            .add([buttonCircleTimeline, buttonCircleTextTimeline])
    }

    onTouchStart() {
        let time = 0
        const $this = this
        const segment = 50
        this.interval = setInterval( () => {
            time = time + segment
            this.setState({
                percentage: time / $this.state.timeToLoad * 100 
            })
            if (time >= $this.state.timeToLoad) {
                clearInterval($this.interval)
                $this.onTouchComplete()
            }
        }, segment)
    }

    onTouchEnd() {
        clearInterval(this.interval)
        this.setState({
            percentage: 0
        })
    }

    onTouchComplete() {
        const node = ReactDOM.findDOMNode(this.props.target);
        if (node) {
            node.classList.toggle('active')
        }
        
        if (this.props.callback) { 
            this.props.callback(true)
        }

    }

    render() {
        return (
            <ButtonWrap 
                onTouchStart={this.onTouchStart} 
                onTouchEnd={this.onTouchEnd} 
                onMouseDown={this.onTouchStart} 
                onMouseUp={this.onTouchEnd}
            >
                <CircularProgressbar 
                    strokeWidth={30}
                    value={this.state.percentage} 
                    styles={{
                        path: {
                            // Path color
                            stroke: `rgba(255, 255, 255, ${this.state.percentage / 100})`,
                            // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
                            strokeLinecap: 'butt',
                            transition: 'stroke-dashoffset 0.1s ease 0s',
                        },
                        // Customize the circle behind the path, i.e. the "total progress"
                        trail: {
                            // Trail color
                            stroke: 'transparent',
                        },
                    }}
                />
                <CircleWrap>
                    <Circle ref={circle => this.circle = circle} />
                    <CircleText ref={circleText => this.circleText = circleText}>
                        {isTouchDevice() ? (
                            <span>touch</span>
                        ) : (
                            <span>click</span>
                        )}
                        &nbsp;&<br /> hold
                    </CircleText>
                </CircleWrap>
            </ButtonWrap>
        )
    }
}

export default ButtonSwipe